module.exports = __webpack_public_path__ + "static/media/cart.456fe0cd.svg";